import { memo } from 'react'
import BaseStep from '@/components/BaseStep/BaseStep'
import './BasicStep.less'
const BasicStep = ({ step, list, onConfirm, isGradient, payment_state, type }: any) => {
  return (
    <div className={`BasicStep-container`}>
      <BaseStep
        step={step}
        onConfirm={onConfirm}
        list={list}
        payment_state={payment_state}
        type={type}
        style={isGradient ? { background: 'linear-gradient(136.14deg, rgba(142,97,241,1) 1.14%,rgba(255,69,148,1) 96.78%)' } : {}}
      />
    </div>
  )
}

export default memo(BasicStep)
